<script setup lang="ts">
import { IconButton } from '@/components/Buttons'
import { VueElement } from 'vue'
import DialogTitle from './DialogTitle.vue'

type Props = {
    title: string
    actions?: VueElement[]
}
defineProps<Props>()
defineEmits<{
    (e: 'close', event: MouseEvent): void
}>()
</script>

<template>
    <DialogTitle :title="title" />
    <IconButton class="delete" @click="$emit('close', $event)" />
</template>
